<template>
  <div class="px-10">
    <v-row>
      <v-col>
        <span class="font-weight-medium pr-3">Employee Movement</span>
      </v-col>
    </v-row>

    <v-row no-gutters>
      <v-col
        v-if="loading"
        cols="4"
        class="text-center ma-auto"
      >
        <v-progress-circular
          indeterminate
          color="primary"
        />
      </v-col>
      <v-col
        v-else
        cols="12"
      >
        <v-timeline>
          <v-timeline-item
            v-for="movement in movements"
            :key="movement.id"
            small
            color="#4A89C7 "
          >
            <v-card
              color="#4A89C7 "
              dark
            >
              <v-list
                one-line
                color="#4A89C7 "
              >
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-medium text-capitalize">
                      {{ $moment(movement.date ).format('D MMM YYYY') }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>

              <v-card-text class="white black--text">
                <v-row
                  v-for="record in movement.records"
                  :key="record.id"
                  no-gutters
                >
                  <v-col
                    cols="3"
                    class="font-weight-bold"
                  >
                    <span v-if="record.movement_action === 'join_date'">Join Date</span>
                    <span v-if="record.movement_action === 'promotion'">Promoted To</span>
                    <span v-if="record.movement_action === 'demotion'">Demoted To</span>
                    <span v-if="record.movement_action === 'probation'">Probation Position</span>
                    <span v-if="record.movement_action === 'change_of_position'">Change Of Position</span>
                    <span v-if="record.movement_action === 'change_of_company'">Change Of Company</span>
                    <span v-if="record.movement_action === 'position'">Position</span>
                    <span v-if="record.movement_action === 'department'">Department</span>
                    <span v-if="record.movement_action === 'superior'">Superior</span>
                    <span v-if="record.movement_action === 'new_payroll_company'">Payroll Company (Start)</span>
                    <span v-if="record.movement_action === 'end_payroll_company'">Payroll Company (End)</span>
                    <span v-if="record.movement_action === 'cost_center'">Cost Center (Start)</span>
                    <span v-if="record.movement_action === 'end_cost_center'">Cost Center (End)</span>
                    <span v-if="record.movement_action === 'basic_salary'">Basic Salary</span>
                    <span v-if="record.movement_action === 'confirmation'">Confirmation</span>
                    <span v-if="record.movement_action === 'resignation'">Resignation</span>
                    <span v-if="record.movement_action === 'others'">Other Position</span>
                  </v-col>
                  <v-col cols="1">
                    :
                  </v-col>
                  <v-col cols="7">
                    <span v-if="record.movement_action === 'join_date'">{{ $moment(((record || {}).hirement || {}).joined_date).format('D MMMM YYYY') }}</span>
                    <span v-if="record.movement_action === 'promotion'">{{ (((record || {}).position || {}).name) + (record.position.deleted_at ? ' (Deleted)' : '') }}</span>
                    <span v-if="record.movement_action === 'demotion'">{{ (((record || {}).position || {}).name) + (record.position.deleted_at ? ' (Deleted)' : '') }}</span>
                    <span v-if="record.movement_action === 'probation'">{{ (((record || {}).position || {}).name) + (record.position.deleted_at ? ' (Deleted)' : '') }}</span>
                    <span v-if="record.movement_action === 'change_of_position'">{{ (((record || {}).position || {}).name) + (record.position.deleted_at ? ' (Deleted)' : '') }}</span>
                    <span v-if="record.movement_action === 'change_of_company'">{{ (((record || {}).position || {}).name) + (record.position.deleted_at ? ' (Deleted)' : '') }}</span>
                    <span v-if="record.movement_action === 'position'">{{ (((record || {}).position || {}).name) + (record.position.deleted_at ? ' (Deleted)' : '') }}</span>
                    <span v-if="record.movement_action === 'department'">{{ (((record || {}).department || {}).name) + (record.department.deleted_at ? ' (Deleted)' : '') }}</span>
                    <span v-if="record.movement_action === 'superior'">{{ ((((record || {}).employee || {}).person || {}).name) }}</span>
                    <span v-if="record.movement_action === 'new_payroll_company'">{{ ((((record || {}).company_employee || {}).company || {}).name) + ((((record || {}).company_employee || {}).company || {}).deleted_at ? ' (Deleted)' : '') }}</span>
                    <span v-if="record.movement_action === 'end_payroll_company'">{{ ((((record || {}).company_employee || {}).company || {}).name) + ((((record || {}).company_employee || {}).company || {}).deleted_at ? ' (Deleted)' : '') }}</span>
                    <span v-if="record.movement_action === 'cost_center'">{{ ((((record || {}).company_employee_cost_center || {}).cost_center || {}).name) }}</span>
                    <span v-if="record.movement_action === 'end_cost_center'">{{ ((((record || {}).company_employee_cost_center || {}).cost_center || {}).name) }}</span>
                    <span v-if="record.movement_action === 'basic_salary'">{{ (Math.round((record.company_employee.temp_basic_salary / 100) * 100) / 100).toFixed(2) }}</span>
                    <span v-if="record.movement_action === 'confirmation'">{{ $moment(((record || {}).hirement || {}).confirmed_date).format('D MMMM YYYY') }}</span>
                    <span v-if="record.movement_action === 'resignation'">{{ record.separation? $moment(((record || {}).separation || {}).last_working_date).format('D MMMM YYYY'):$moment(((record || {}).employee || {}).last_working_date).format('D MMMM YYYY') }}</span>
                    <span v-if="record.movement_action === 'others'">{{ (((record || {}).position || {}).name) + (record.position.deleted_at ? ' (Deleted)' : '') + ' (' + record.remark + ')' }}</span>
                  </v-col>

                  <v-col cols="1">
                    <employee-profile-movement-dialog-delete
                      v-if="(record.effective_date >= $moment().format('Y-M-D')) && $hasPermissionTo(['delete employee movements'])"
                      :movement="record"
                      @deleted="loadEmployeeMovements"
                    />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-timeline-item>
        </v-timeline>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  export default {
    components: {
      // EmployeeProfileMovementDialogEdit: () => import('@/components/hris/employee/profile/movement/DialogEdit'),
      EmployeeProfileMovementDialogDelete: () => import('@/components/hris/employee/profile/movement/DialogDelete'),
    },
    props: {
      employeeUid: {
        type: String,
        required: true,
      },
    },
    data () {
      return {
        loading: false,
        movements: [],
      }
    },

    watch: {
      employeeUid: {
        immediate: true,
        handler (newVal, oldVal) {
          if (!_.isEmpty(newVal)) {
            this.loadEmployeeMovements()
          }
        },
      },
    },
  
    methods: {
      loadEmployeeMovements () {
        this.movements = []
        this.loading = true

        this.$api.employeeMovements().list(this.employeeUid)
          .then(res => {
            _.chain(res.data)  
              .groupBy('effective_date')
              .map((value, key) => {
                this.movements.push({
                  date: key,
                  records: value,
                })
              }).value()
   
            this.$emit('loaded')
            this.loading = false
          })
      },
    },
  }
</script>

<style scoped>
.blue--text{
  color: #26c6da !important;
}

.font-11{
  font-size:11px !important
}
</style>
